

































import { Vue, Component, Prop, Emit, Model } from 'vue-property-decorator'
import { randKey } from '@/utils/random'
import Button from './presets/Button.vue'
import { QueryParam } from './query'
import { Column } from './column'

@Component({
  components: { Button }
})
export default class TableHeader<T> extends Vue {
  @Prop({ type: Object, required: true }) column!: Column<T>
  search = { value: '' }
  randKey = randKey()

  handleSearch() {
    const col = this.column as any
    const payload: QueryParam = {
      field: (col.query && col.query.field) || col.prop,
      value: this.search.value,
      method: (col.query && col.query.method) || '='
    }
    this.$emit('search', payload)
  }

  handleClick(event: string) {
    this.$emit('click', event)
  }
}
